export default __webpack_public_path__ + "static/07-b0de17d40d454f5326d2cfde9e6deeeb.jpg";